export default __webpack_public_path__ + "static/media/gallery-wip-neck-grenade_01.94787ca1.jpg";